var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackOfficeTraywhiteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9166 10.4167V14.5833M2.70825 4.16667H9.14367C9.29263 4.16666 9.4367 4.21986 9.54992 4.31667L12.8458 7.14167C12.959 7.23849 13.103 7.29168 13.252 7.29167H22.2916C22.3737 7.29167 22.4549 7.30784 22.5308 7.33925C22.6066 7.37066 22.6755 7.41669 22.7335 7.47473C22.7916 7.53277 22.8376 7.60167 22.869 7.67749C22.9004 7.75332 22.9166 7.8346 22.9166 7.91667V10.8333C22.9166 10.9154 22.9004 10.9967 22.869 11.0725C22.8376 11.1483 22.7916 11.2172 22.7335 11.2753C22.6755 11.3333 22.6066 11.3794 22.5308 11.4108C22.4549 11.4422 22.3737 11.4583 22.2916 11.4583H2.70825C2.54249 11.4583 2.38352 11.3925 2.26631 11.2753C2.1491 11.1581 2.08325 10.9991 2.08325 10.8333V4.79167C2.08325 4.62591 2.1491 4.46694 2.26631 4.34973C2.38352 4.23252 2.54249 4.16667 2.70825 4.16667Z",
    stroke: "white",
    strokeWidth: 1.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.08325 10.4167V20.2083C2.08325 20.3741 2.1491 20.5331 2.26631 20.6503C2.38352 20.7675 2.54249 20.8333 2.70825 20.8333H13.5416M19.7916 21.875C20.3441 21.875 20.874 21.6555 21.2647 21.2648C21.6554 20.8741 21.8749 20.3442 21.8749 19.7917C21.8749 19.2391 21.6554 18.7092 21.2647 18.3185C20.874 17.9278 20.3441 17.7083 19.7916 17.7083C19.2391 17.7083 18.7091 17.9278 18.3184 18.3185C17.9277 18.7092 17.7083 19.2391 17.7083 19.7917C17.7083 20.3442 17.9277 20.8741 18.3184 21.2648C18.7091 21.6555 19.2391 21.875 19.7916 21.875Z",
    stroke: "white",
    strokeWidth: 1.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7915 22.9167C20.6203 22.9167 21.4152 22.5874 22.0012 22.0014C22.5873 21.4153 22.9165 20.6205 22.9165 19.7917C22.9165 18.9629 22.5873 18.168 22.0012 17.582C21.4152 16.9959 20.6203 16.6667 19.7915 16.6667C18.9627 16.6667 18.1678 16.9959 17.5818 17.582C16.9957 18.168 16.6665 18.9629 16.6665 19.7917C16.6665 20.6205 16.9957 21.4153 17.5818 22.0014C18.1678 22.5874 18.9627 22.9167 19.7915 22.9167Z",
    stroke: "white",
    strokeWidth: 1.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.31 2.08"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackOfficeTraywhiteIcon);
export default __webpack_public_path__ + "static/media/Back Office Tray whiteIcon.085daa8bc839f787d13c7dcee022083c.svg";
export { ForwardRef as ReactComponent };